module.exports = __webpack_public_path__ + "img/21.f0e9a98d.jpg";